import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';


@Injectable()
export class HttpProvider {

  constructor(public http: HttpClient) {
  }

  get(url: string, options) {
    return this.http.get(url, options);
  }

  post(url, data, options) {
    return this.http.post(url, data, options);
  }

  delete(url, options) {
    return this.http.delete(url, options);
  }
}



// WEBPACK FOOTER //
// ./src/providers/http/http.ts